// src/api/purchases.js
import { BASE_API } from "../utils/constants";

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export async function getPurchasesApi(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${BASE_API}/api/finance/purchases/${query ? `?${query}` : ""}`;
  const res = await fetch(url, { headers: authHeader(token) });
  if (!res.ok) throw new Error("Error al cargar compras");
  return await res.json();
}

export async function createPurchaseApi(data, token) {
  const url = `${BASE_API}/api/finance/purchases/`;
  const res = await fetch(url, {
    method: "POST",
    headers: { ...authHeader(token), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw json;
  return json;
}

export async function updatePurchaseApi(id, data, token) {
  const url = `${BASE_API}/api/finance/purchases/${id}/`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: { ...authHeader(token), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw json;
  return json;
}

export async function deletePurchaseApi(id, token) {
  const url = `${BASE_API}/api/finance/purchases/${id}/`;
  const res = await fetch(url, { method: "DELETE", headers: authHeader(token) });
  if (!res.ok) throw new Error("No se pudo eliminar la compra");
  return true;
}

/* ===== Adjuntos (multipart) ===== */
export async function listPurchaseAttachmentsApi(purchaseId, token) {
  const url = `${BASE_API}/api/finance/purchase-attachments/?purchase=${purchaseId}`;
  const res = await fetch(url, { headers: authHeader(token) });
  if (!res.ok) throw new Error("Error al cargar adjuntos");
  return await res.json();
}

export async function uploadPurchaseAttachmentApi({ purchase, file, kind = "invoice_pdf" }, token) {
  const url = `${BASE_API}/api/finance/purchase-attachments/`;
  const form = new FormData();
  form.append("purchase", purchase);
  form.append("kind", kind);
  form.append("file", file);
  const res = await fetch(url, { method: "POST", headers: authHeader(token), body: form });
  const json = await res.json();
  if (!res.ok) throw json;
  return json;
}

export async function deletePurchaseAttachmentApi(id, token) {
  const url = `${BASE_API}/api/finance/purchase-attachments/${id}/`;
  const res = await fetch(url, { method: "DELETE", headers: authHeader(token) });
  if (!res.ok) throw new Error("No se pudo eliminar el adjunto");
  return true;
}
